import * as Business   from '../business';
import * as Forms      from '../components/forms';
import * as User       from '../user';
import { compose }     from 'redux';
import { connect }     from 'react-redux';
import FetchFromServer from '../components/fetch_from_server';
import Navbar          from '../components/navbar';
import React           from 'react';
import RolesInfo       from './roles_info';


export default connect(
  (state, { businessID, providerID }) => ({
    providerID,
    availableRoles: User.getAvailableRoles(state),
    statuses:       Business.getTeamStatuses(state, businessID),
    team:           Business.getTeam(state, businessID)
  }),
  (dispatch, { businessID, navigateBackTo }) => ({
    load:   compose(dispatch, Business.readTeam, () => businessID),
    invite: compose(dispatch, Business.inviteProvider, provider => ({ businessID, provider, params: { showDefaultErrorUI: false } })),
    navigateBackTo,
    businessID
  })
)(ProviderPage);


export function ProviderPage({ businessID, providerID, team, availableRoles, statuses, load, invite, navigateBackTo }) {
  const provider = getProvider(team, providerID);

  async function onInvite(data) {
    await invite(data);
    navigateBackTo(`/${businessID}/settings/team`);
  }

  const title = provider?.name || 'Invite Team Member';

  return (
    <React.Fragment>
      <Navbar title={title} backLink/>
      <FetchFromServer statuses={statuses} load={load} ptr={false}>
        {provider && (
          <Forms.Form record={provider} validate={validate} save={onInvite}>
            <ProviderForm availableRoles={availableRoles}/>
          </Forms.Form>
        )}
      </FetchFromServer>
    </React.Fragment>
  );
}


function validate({ phone, email }) {
  if (!phone && !email)
    throw new Error('To sign in, please provide an email address or phone number');
}

function getProvider(team, providerID) {
  const defaultProvider = { role: 'member' };

  if (providerID) {
    const provider = findProvider({ team, providerID });
    return {
      ...defaultProvider,
      ...provider
    };
  } else
    return defaultProvider;
}

function findProvider({ team, providerID }) {
  return (team?.providers.find(item => item.id === providerID));
}


function ProviderForm({ availableRoles, ...form }) {
  return (
    <div className="list block">
      <ul>
        <Forms.Error {...form}/>
        <Forms.Input  {...form} label="Name" name="name" type="text" required={true}/>
        <Forms.Input  {...form} label="Phone number" name="phone" type="tel"/>
        <Forms.Input  {...form} label="Email" name="email" type="email"/>
        <Forms.Input  {...form} label="Job title" name="title" type="text"/>
        <Forms.Select {...form} label="App Role" name="role" options={availableRoles}/>
        <RolesInfo roles={availableRoles}/>
        <Forms.Button {...form} label="Invite New Member"/>
      </ul>
    </div>
  );
}
